type GetPanelViewportTransformParams = {
  faceType: string;
  halfWidth: number;
  panelScale: number;
};

/**
 * Returns the 6-element fabric.js viewport transform array for a split panel.
 * The right panel is translated left so its content starts at pixel 0.
 */
export const getPanelViewportTransform = ({
  faceType,
  halfWidth,
  panelScale,
}: GetPanelViewportTransformParams): [number, number, number, number, number, number] => {
  const translateX = faceType === 'inside-right' ? -halfWidth * panelScale : 0;
  return [panelScale, 0, 0, panelScale, translateX, 0];
};
